import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { getPlayer } from '../../../services/player/player-service';
import DailyProgressCheckbox from '../../components/player-daily-progress/daily-progress-checkbox';

import SupinationPronationSection from '../../components/player-overview-charts/supination-pronation-section';

import { getPlayerProgress, getProgressKeys } from '../../../modules/result_api';

import PlayerProgressChart from './player_progress_chart';

import PlayerDashboardButtons from '../../components/player-dashboard-buttons/player-dashboard-buttons';

import './player_progress_dashboard.css';

// import {Col} from "reactstrap";

class PlayerProgressDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      player: -1,
      gameID: -1,
      skillID: -1,
      positionID: -1,
      progressKeys: [],
      loadingData: false,
      getData: false,
      chartsInfo: [],
      checkboxData: [],
      checkedCheckboxes: {},
      checkboxesChanged: false,
    };
  }

  titleCase(str) {
    const splitStr = str.toLowerCase().split(' ');
    for (let i = 0; i < splitStr.length; i++) {
      // You do not need to check if i is larger than splitStr length, as your for does that for you
      // Assign it back to the array
      splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
  }

  handleCheckboxChange(positionID, checked) {
    const { checkedCheckboxes } = this.state;

    const newCheckboxes = { ...checkedCheckboxes };
    if (!checked) {
      delete newCheckboxes[positionID];
    } else {
      newCheckboxes[positionID] = true;
    }

    this.setState({
      checkedCheckboxes: newCheckboxes,
      checkboxesChanged: true,
      getData: true,
    });
  }

  preparePositionCheckboxes(progressKeys) {
    const positions = {};
    const checkboxData = [];

    let currentKeySet;
    for (const index in progressKeys) {
      currentKeySet = progressKeys[index];

      const positionName = currentKeySet.position_name;
      const positionID = currentKeySet.position_id;

      if (!positions[positionID]) {
        positions[positionID] = positionName;
        checkboxData.push({
          position_id: positionID,
          position_name: positionName,
        });
      }
    }

    this.setState({ checkboxData: checkboxData });
  }

  printCheckboxes() {
    const { checkboxData } = this.state;
    return checkboxData.map((item) => (
      <DailyProgressCheckbox
        position_id={item.position_id}
        position_name={item.position_name}
        handleClick={this.handleCheckboxChange.bind(this)}
      ></DailyProgressCheckbox>
    ));
  }

  prepareProgressKeyStringName(keySet) {
    // let gameName = keySet.game_name;
    const skillName = keySet.skill_name;
    const positionName = keySet.position_name;
    const relevant_key = this.titleCase(keySet.relevant_key.replace(/_/g, ' '));
    const funcType = keySet.func_type;
    const gameImagePath = keySet.game_image;
    return [skillName + ', ' + positionName, relevant_key, funcType, gameImagePath];
  }

  shouldCheckProgressKey(progressKey) {
    const { checkedCheckboxes } = this.state;
    const positionID = progressKey.position_id;
    return checkedCheckboxes[positionID];
  }

  async getProgressKeysData(playerID) {
    this.setState({ loadingData: true });
    const { progressKeys } = this.state;
    let chartsInfo = [];

    let currentKeySet;
    for (const index in progressKeys) {
      currentKeySet = progressKeys[index];
      if (!this.shouldCheckProgressKey(currentKeySet)) {
        continue;
      }

      const resultsInfo = await getPlayerProgress(
        playerID,
        currentKeySet.game_id,
        currentKeySet.skill_id,
        currentKeySet.position_id,
        currentKeySet.func_type,
        currentKeySet.relevant_key
      );
      if (resultsInfo && resultsInfo.data && resultsInfo.data.success) {
        chartsInfo.push([resultsInfo.data.data, this.prepareProgressKeyStringName(currentKeySet)]);
      }
    }

    let gotChartsInfo = false;
    let currentInfo;
    for (const index in chartsInfo) {
      currentInfo = chartsInfo[index];
      if (currentInfo[0] && typeof currentInfo === 'object' && Object.keys(currentInfo[0]).length > 0) {
        gotChartsInfo = true;
        break;
      }
    }

    if (!gotChartsInfo) {
      chartsInfo = [];
    }

    this.setState({ loadingData: false, chartsInfo: chartsInfo, getData: false });
  }

  async componentDidMount() {
    const { getData } = this.state;
    const progressKeys = await getProgressKeys();

    this.setState({ progressKeys: progressKeys.data.data });

    const playerID = this.props.match.params.id;
    const player = await getPlayer(playerID, this.props);
    this.setState({ player: player });
    if (playerID && getData) {
      this.setState({ getData: false });
      this.getProgressKeysData(playerID);
    }

    if (progressKeys.data.data) {
      this.preparePositionCheckboxes(progressKeys.data.data);
    }
  }

  componentDidUpdate() {
    const { getData } = this.state;

    const playerID = this.props.match.params.id;
    if (playerID && getData) {
      this.setState({ getData: false });
      this.getProgressKeysData(playerID);
    }
  }

  render() {
    const { loadingData, chartsInfo, player, getData, checkedCheckboxes } = this.state;

    const hasCheckedFilters =
      Object.entries(checkedCheckboxes).length !== 0 && checkedCheckboxes.constructor === Object;
    return (
      <div>
        <PlayerDashboardButtons player={player} activePage="progressDashboard" isTherapistRole={true} />
        <div>Daily Progress Filters:</div>
        {this.printCheckboxes()}
        {loadingData && (
          <div>
            Loading<i className="fa fa-spinner fa-spin"></i>
          </div>
        )}

        {!loadingData && chartsInfo.length > 0 && (
          <div className="player_progress_dashboard_container">
            {chartsInfo.map((data) => (
              <PlayerProgressChart title="a progress chart" data={data}></PlayerProgressChart>
            ))}
          </div>
        )}

        {!loadingData && chartsInfo.length === 0 && !getData && hasCheckedFilters && (
          <div className="player_progress_dashboard_no_data_message">There is no progress data to show...</div>
        )}
        {!loadingData && chartsInfo.length === 0 && !getData && !hasCheckedFilters && (
          <div className="player_progress_dashboard_no_data_message">Select filters to see results</div>
        )}

        {this.props.angles_data && <SupinationPronationSection angle_data={this.props.angles_data} />}
      </div>
    );
  }
}

const withState = connect((state) => {
  const { game, game_session, player, position, skill, user, result } = state;

  const games = game.games;
  const gameSessions = game_session.game_sessions;
  const players = player.players;
  const positions = position.positions;
  const skills = skill.skills;

  return {
    games: games,
    gameSessions: gameSessions,
    players: players,
    positions: positions,
    skills: skills,
    user: user,
    angles_data: result.angle_data,
    playerID: player.id,
    currentUserId: user.currentUserId,
    isTherapistRole: user.isTherapistRole,
  };
});

export default withRouter(withState(PlayerProgressDashboard));
